import React from "react";
import { cn } from "../../../common/u1/cn";

/* A bordered panel with a coloured top edge, an eyebrow pill and a standfirst. */
const ACCENTS = {
  gold: {
    edge: "border-t-[var(--gold-star)]",
    pill: "bg-[var(--gold-soft)] text-[var(--gold-deep)]",
  },
  green: {
    edge: "border-t-[var(--success)]",
    pill: "bg-[var(--success-soft)] text-[var(--success)]",
  },
};

export const PanelCard = ({
  accent = "gold",
  eyebrow,
  title,
  intro,
  children,
  className = "",
}) => {
  const a = ACCENTS[accent] || ACCENTS.gold;

  return (
    <section
      className={cn(
        "flex flex-col rounded-[14px] border border-[var(--line)] bg-white p-6",
        "border-t-[3px] shadow-[0_1px_2px_rgba(0,0,0,.04)]",
        a.edge,
        className
      )}
    >
      <div className="mb-1.5 flex flex-wrap items-center gap-2.5">
        {eyebrow && (
          <span
            className={cn(
              "inline-flex items-center rounded-md px-[9px] py-1",
              "text-[11px] font-bold uppercase tracking-[.6px] font-sans",
              a.pill
            )}
          >
            {eyebrow}
          </span>
        )}
        {title && (
          <h3 className="m-0 text-[17px] font-bold text-[var(--ink)] font-sans">{title}</h3>
        )}
      </div>

      {intro && (
        <p className="mt-0 mb-[18px] text-[13.5px] leading-[1.5] text-[var(--muted)] font-sans">
          {intro}
        </p>
      )}

      {children}
    </section>
  );
};

export default PanelCard;
